import { memo, useEffect, useState } from "react";
import Tooltip from "./Tooltip";
import { getSearchParams } from "@/lib/utils";
import { ERROR_CODE_SEARCH_PARAM } from "@/consts";
import { ERROR_MESSAGE } from "@/consts/errors";

type Props = {
  errorCode?: string;
  className?: string;
};
const ErrorTooltip = ({ errorCode, className }: Props) => {
  const [code, setCode] = useState(errorCode);

  useEffect(() => {
    // errorCode를 직접 설정할 경우 우선순위 1
    if (errorCode) {
      setCode(errorCode);
      return;
    }

    // errorMessage 얻기
    const queryErrorCode = getSearchParams(ERROR_CODE_SEARCH_PARAM);
    if (queryErrorCode) {
      setCode(queryErrorCode);
    }
  }, [errorCode]);

  if (!code) {
    return null;
  }
  return (
    <Tooltip variant={"error"} className={className}>
      {ERROR_MESSAGE[code] ||
        `시스템 오류로 로그인에 실패하였습니다. \n잠시 후 다시 로그인을 시도해주세요. \n계속해서 동일한 오류가 발생하는 경우 \n넥슨 고객센터로 문의해주세요. (${code})`}
    </Tooltip>
  );
};

export default memo(ErrorTooltip);
